export const environment = {
  production: true,
  apiEndPoint: 'https://app-faceapi-idec.azurewebsites.net/api',
  appToken: 'cCUMmLhNf0FACHu47FMaI1E8RIYyvNVp8uHSR85KZWGkZq9UoSnbOUm2lolAK0aXqmqt+NyWfUp3D3Vx1mMveg==',
  appId: '6469e2e493313eb9e96369c9',
  secretKey: '66546A576D5A7134',
  sas: '?sp=racwdl&st=2023-07-10T16:51:52Z&se=2030-08-01T00:51:52Z&spr=https&sv=2022-11-02&sr=c&sig=tHY4M3O8k8dHw7G9nS5fsS4tcqTQKGbRRLeTCn1Ae6E%3D',
  azureBlobBaseUrl: 'https://az0blob0idec.blob.core.windows.net',
  hereTileUrl: 'https://maps.hereapi.com/v3/base/mc/{z}/{x}/{y}/png',
  hereReverseGeocodeUrl: 'https://search.hereapi.com/v1/revgeocode'
};